module.exports = __webpack_public_path__ + "static/img/2108_phase_function_Paper_Points.723962b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2108_phase_function_Paper_Points.png
// module id = ymvD
// module chunks = 0